import { Component, OnChanges, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { GenService } from 'app/shared/gen-ser.service';
import { DataService } from 'app/shared/dataservice.service';
import { FinishedGoodsToken, FinishedGoodsDaily } from 'app/shared/misc-classes';
import { ModalDirective } from 'ngx-bootstrap';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'finished-goods-day-view',
  templateUrl: './finished-goods-day-view.component.html',
  styleUrls: ['./finished-goods-day-view.component.css']
})
export class FinishedGoodsDayViewComponent implements OnChanges,OnInit {

  editHeader: string = "";
  modalErrorMessage: string = "";
  editFgCurrentDayObj: FinishedGoodsDaily;

  @Input() currMonthDtObj: Date;
  @Input() mId: string;
  @Input() fgCurrentDayObj: FinishedGoodsDaily;

  @Output() dateChanged: EventEmitter<any> = new EventEmitter();
  @Output() reloadData: EventEmitter<any> = new EventEmitter();
  @ViewChild('childModal') public childModal: ModalDirective;

  CBList:Array<dropFilterItem> = [];
  selectedCBs:Array<string> = [];

  SOIncoTermList:Array<dropFilterItem> = [];
  selectedSOIncoTerms:Array<string> = [];

  CustomerList:Array<dropFilterItem> = [];
  selectedCustomers:Array<string> = [];

  PSRefList:Array<dropFilterItem> = [];
  selectedPSRef: Array<string> = [];

  EquipmentList: Array<dropFilterItem> = [];
  selectedEquipment: Array<string> = [];

  TypeList: Array<dropFilterItem> = [];
  selectedType: Array<string> = [];

  OHEList:Array<dropFilterItem> = [];
  selectedOHEs:Array<string> = [];

  totalRecordsCount:number = 0;
  filteredRecordsCount:number = 0;
  totalQuantity:number = 0;
  constructor(private _dataService: DataService, private _notify: NotificationsService) { }

  ngOnInit(){
    this.reloadFilters();
  }
  ngOnChanges() {

    this.reloadFilters();

  }

  filterFGTokens():Array<FinishedGoodsToken>{
    let _tmpTotalQuantity:number = 0;
    let _filteredFGTokens:Array<FinishedGoodsToken> = this.fgCurrentDayObj.FGTokens.filter((_tmpFGToken:FinishedGoodsToken) => {

        if(this.selectedCustomers && this.selectedCustomers.length > 0){
          if(this.selectedCustomers.indexOf(_tmpFGToken.customer) < 0){
            return false;
          } 
        }

        if(this.selectedPSRef && this.selectedPSRef.length > 0){
          if(this.selectedPSRef.indexOf(_tmpFGToken.psRef) < 0){
            return false;
          }
        }

        if(this.selectedEquipment && this.selectedEquipment.length > 0){
          if(this.selectedEquipment.indexOf(_tmpFGToken.equipment) < 0){
            return false;
          }
        }
        if(this.selectedType && this.selectedType.length > 0){
          if(this.selectedType.indexOf(_tmpFGToken.equipment) < 0){
            return false;
          }
        }

        _tmpTotalQuantity += Number(_tmpFGToken.planQty);
      
        return true;
    });
    this.totalQuantity = _tmpTotalQuantity;
    this.filteredRecordsCount = _filteredFGTokens.length;
    return _filteredFGTokens;
  }

  reloadFilters(){
    this.totalRecordsCount = this.fgCurrentDayObj.FGTokens.length;
    this.filteredRecordsCount = 0;
  
    let _tmpCustomerList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _customer:string = _tmpFGToken.customer;
      let _tmpDropItem:dropFilterItem = _tmpCustomerList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _customer;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tmpCustomerList.push(new dropFilterItem(_customer,_customer))    
      }

    });
    _tmpCustomerList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.CustomerList = _tmpCustomerList;

    let _tempPSRefList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _PSRef:string = _tmpFGToken.psRef;
      let _tmpDropItem:dropFilterItem = _tmpCustomerList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _PSRef;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tempPSRefList.push(new dropFilterItem(_PSRef,_PSRef))    
      }

    });
    _tempPSRefList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.PSRefList = _tempPSRefList;

    let _tempEquipmentList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _equipment:string = _tmpFGToken.equipment;
      let _tmpDropItem:dropFilterItem = _tmpCustomerList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _equipment;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tempEquipmentList.push(new dropFilterItem(_equipment,_equipment))    
      }

    });
    _tempEquipmentList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.EquipmentList = _tempEquipmentList;

    let _tempTypeList:Array<dropFilterItem> = [];
    this.fgCurrentDayObj.FGTokens.forEach((_tmpFGToken:FinishedGoodsToken) =>{
      let _type:string = _tmpFGToken.type;
      let _tmpDropItem:dropFilterItem = _tmpCustomerList.find((_tmpDropItem:dropFilterItem) => {
        return _tmpDropItem.ItemId == _type;
      });

      if(_tmpDropItem){
        _tmpDropItem.itemFoundAgain();
      }
      else{
        _tempTypeList.push(new dropFilterItem(_type,_type))    
      }

    });
    _tempTypeList.sort((_a:dropFilterItem,_b:dropFilterItem) =>{
      if(_a.ItemId < _b.ItemId) return -1;
      if(_a.ItemId > _b.ItemId) return 1;
      return 0;
    });
    this.TypeList = _tempTypeList;

  }

  formatDate(excelDate){
    if(excelDate && excelDate == parseInt(excelDate,10)){
    var m_names = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
    var _dt = new Date((excelDate - (25567 + 2))*86400*1000)
    return _dt.getDate()+"-"+m_names[_dt.getMonth()];
  }
  return excelDate;
  }

  formatHeaderDate(_date: Date): string {
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  prevDateSel(): void {
    let _newDate: Date = new Date(this.currMonthDtObj.getTime());
    _newDate.setDate(_newDate.getDate() - 1);
    this.dateChanged.emit({ "date": _newDate });
  }
  nextDateSel(): void {
    let _newDate: Date = new Date(this.currMonthDtObj.getTime());
    _newDate.setDate(_newDate.getDate() + 1);
    this.dateChanged.emit({ "date": _newDate });
  }

  hasEditAccess(_pid: string) {
    return this._dataService.hasEditAccess(this.mId, _pid);
  }
  editStatus() {
    this.editFgCurrentDayObj = this.fgCurrentDayObj.cloneSelf();
    this.showChildModal();
  }

  hasReadAccess(_pid: string) {
    return this._dataService.hasReadAccess(this.mId, _pid);
  }
  showChildModal() {
    this.editHeader = "Edit Finished Goods Status";
    this.childModal.show();
  }
  hideChildModal() {
    this.childModal.hide();
  }
  saveChanges() {
    if (this.validateData() == true) {
      this._dataService.saveFgMonthlyData(this.editFgCurrentDayObj).subscribe((res: boolean) => {
        if (res == true) {
          this._notify.success('Success', 'Data Saved.', this._dataService.successOptions);
          this.hideChildModal();
          this.reloadData.emit();
        }
        else {
          this._notify.error('Failure', 'Failed to Save.', this._dataService.failureOptions);
        }
      });
    }
  }

  validateData(): boolean {
    if (this.editFgCurrentDayObj.cb == "" || !GenService.IsValidNumber(this.editFgCurrentDayObj.cb) == true) {
      this.modalErrorMessage = 'CB value should be a Number.';
      return false;
    }
    if (this.editFgCurrentDayObj.module == "" || !GenService.IsValidNumber(this.editFgCurrentDayObj.module)== true) {
      this.modalErrorMessage = 'Module value should be a Number.';
      return false;
    }
    if (this.editFgCurrentDayObj.looseKit =="" || !GenService.IsValidNumber(this.editFgCurrentDayObj.looseKit) == true) {
      this.modalErrorMessage = 'Loose Kit value should be a Number.';
      return false;
    }

    return true;
  }
}


class dropFilterItem{
  private _counter:number;
  constructor(private _itemLabel:string,public ItemId:string){
    this._counter = 1;
  }

  itemFoundAgain(){
    this._counter++;
  }

  get ItemLabel():string{
    return this._itemLabel +" ("+ this._counter +
          (this._counter == 1 ? " order)":" orders)");;
  }
}